var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitnessLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7541 7.96954C23.1879 7.96954 22.6448 8.19512 22.244 8.59497L16.4533 14.3901L13.6756 11.5452C13.4796 11.3447 13.246 11.1847 12.9883 11.0745C12.7305 10.9642 12.4535 10.9058 12.1731 10.9026C11.8928 10.8994 11.6145 10.9515 11.3543 11.0558C11.094 11.1601 10.8569 11.3147 10.6564 11.5107C10.4559 11.7067 10.2959 11.9402 10.1857 12.198C10.0754 12.4558 10.017 12.7328 10.0138 13.0132C10.0106 13.2935 10.0627 13.5718 10.167 13.832C10.2713 14.0923 10.4259 14.3294 10.6219 14.5299L14.907 18.9194C15.1043 19.1215 15.3399 19.2824 15.5999 19.3928C15.8599 19.5033 16.1392 19.561 16.4217 19.5626C16.7042 19.5642 16.9842 19.5098 17.2455 19.4024C17.5068 19.2951 17.7442 19.1369 17.9439 18.9371L25.2633 11.6151C25.5611 11.3163 25.7638 10.9361 25.8458 10.5223C25.9279 10.1085 25.8856 9.67966 25.7243 9.28987C25.563 8.90008 25.2899 8.56678 24.9394 8.33197C24.589 8.09716 24.1768 7.97136 23.755 7.97043L23.7541 7.96954Z",
    stroke: "#3DBB43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.394 4.25444C27.8529 -0.0492511 20.384 -0.212022 17.3657 4.53044C14.3473 -0.211137 6.87936 -0.0483666 3.33733 4.25444C-5.59294 15.1035 13.6856 29 17.3657 29C21.0457 29 40.3243 15.1026 31.394 4.25444Z",
    stroke: "#3DBB43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessLogo);
export default __webpack_public_path__ + "static/media/fitness-logo.9c448c98b278c703f42f3a3b602767b8.svg";
export { ForwardRef as ReactComponent };